<!--
IDEAS
  - introduce second info text. One to be sticky for the whole progress interval and one to update on each resource load.
  - add the error message if loading fails
-->

<template>
  <div
    id="organisation-splash-wrapper"
    :style="cssVars">
    <div id="organisation-splash">
      <img
        width="105"
        src="~@/assets/img/SB-Images/splash-logo.svg" >
      <b-progress
        :value="progress" />
      <p>Number™</p>
      <p class="message">{{ splashMessage }}</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'OrganisationSplash',
  data() {
    return {
      progress: 0,
      transitionDuration: 0,
      progressSpeed: 20,
      timeToFinish: 100,
      progressInterval: null,
      maxPercentageBeforeFinished: 0,
      speedResetTimeoutsActive: 0,
      splashStartTime: null,
    };
  },
  computed: {
    ...mapGetters({
      showSplash: 'organisation/showSplash',
      splashMessage: 'organisation/splashMessage',
      splashTotal: 'organisation/splashTotal',
      finalizeSplash: 'organisation/finalizeSplash',
    }),
    cssVars() {
      return {
        '--transition-duration': `${this.transitionDuration}ms`,
      };
    },
  },
  watch: {
    showSplash(newValue) {
      if (newValue) {
        this.splashStartTime = Date.now();
      }
    },
    // when total icreasses the progress speed is bumped for a second to make it more dynamic
    splashTotal(newValue) {
      if (newValue > 0) {
        // speead the loader up for a 100ms
        this.resetProgressBarSpeed(10);
        this.speedResetTimeoutsActive++;
        setTimeout(() => {
          this.speedResetTimeoutsActive--;
          if (!this.finalizeSplash && !this.speedResetTimeoutsActive) {
            this.resetProgressBarSpeed(20);
          }
        }, 1000);
      }
    },
    finalizeSplash(newValue) {
      if (newValue) {
        this.finishSplash();
      }
    },
  },
  mounted() {
    this.splashStartTime = Date.now();
    this.initialize();
  },
  methods: {
    ...mapActions({
      hideOrganisationSplash: 'organisation/hideOrganisationSplash',
    }),
    initialize() {
      // Pick a random max percentage between 50% and 95% - this will just make it a bit different each time.
      // In case the page is not loaded completellx and the progressbar reaches random max, the progressbar will stop untill page fully loads.
      // More than enough time is left for the progressbar to reach random max so this should actully not happen in reality unless really bad connection is used.
      this.maxPercentageBeforeFinished = 50 + (Math.random() * 45);
      this.startProgressBar();
    },
    // Progress is done with js and not css because css transition duration cannot be changed dinamically.
    startProgressBar() {
      this.progressInterval = setInterval(() => {
        if (this.progress > this.maxPercentageBeforeFinished) {
          this.stopProgressBar();
        }
        this.progress += 0.1;
      }, this.progressSpeed);
    },
    stopProgressBar() {
      clearInterval(this.progressInterval);
    },
    resetProgressBarSpeed(newSpeed) {
      this.stopProgressBar();
      this.progressSpeed = newSpeed;
      this.startProgressBar();
    },
    finishSplash() {
      this.stopProgressBar();
      const progressToGo = 100 - this.progress;
      let remainingMinTime = process.env.VUE_APP_MIN_SPLASH_TIME - (Date.now() - this.splashStartTime);
      if (remainingMinTime < 200) {
        remainingMinTime = 200;
      }

      const finishInterval = remainingMinTime / 20;
      this.progressInterval = setInterval(() => {
        this.progress += progressToGo / 20;
        if (this.progress >= 100) {
          this.stopProgressBar();
          this.hideOrganisationSplash();
        }
      }, finishInterval);
    },
  },
};
</script>

<style lang="scss" scoped>
#organisation-splash-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  // opacity: 0.3; // For debugging
  right: 0;
  background-image: linear-gradient(117deg, #fffdf4, #f6fff4 38%, #f5feff 61%, #fcf5ff 99%);
  z-index: 9999999999;
  overflow: auto;
  padding: 20px;

  #organisation-splash {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100%;
    // overflow-y: auto;
    // overflow-x: hidden;

    ::v-deep .progress {
      flex-shrink: 0;
      width: 100%;
      max-width: 425px;
      height: 3px;
      background-color: #DCDFE5;
      margin-top: 65px;

      .progress-bar {
        background-color: $blackPrimary;
      }
    }

    p {
      font-size: 24px;
      font-weight: 500;
      color: $blackPrimary;
      margin-top: 55px;
      text-align: center;
      overflow-wrap: anywhere;
      padding: 10px;

      &.message {
        font-size: 18px;
        font-weight: 400;
        color: #9E9FA3;
        margin-top: 0px;
      }
    }
  }
}

::v-deep {
  .progress-bar {
    transition-duration: var(--transition-duration);
  }
}
</style>
